<template>
    <el-dialog width="50%" title="关联人" :visible.sync="innerVisible" append-to-body>
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item>
                <el-input v-model="dataForm.name" placeholder="请输入人名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="getPersonList()">查询</el-button>
            </el-form-item>
        </el-form>
        <div style="height: 70vh; overflow-y: scroll">
            <el-scrollbar>
                <el-table ref="multipleTable" v-loading="dataListLoading" :data="dataList" border
                    @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle"
                    style="width: 100%">
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                    <el-table-column prop="id" label="人员编号" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="xm" label="姓名" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="cjInfo" label="残疾等级" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="mobile" label="联系电话" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="liveAddress" label="住址" header-align="center" align="center"></el-table-column>
                </el-table>
            </el-scrollbar>
        </div>
        <template slot="footer">
            <el-button @click="innerVisible = false">取消</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import mixinViewModule from "@/mixins/view-module";
export default {
    // mixins: [mixinViewModule],
    props: {
        echoList: {
            type: Array,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            // mixinViewModuleOptions: {
            //     getDataListURL: "/cx/cxUserList",
            //     createdIsNeed: false,
            // },
            visible: false,
            dataForm: {
                name: "",
                cunNameList: [],
            },
            innerVisible: false,
            dataList: null,
            dataListLoading: false,
            dataListSelections: [],

        };
    },
    computed: {
        dataRule() {
            return {
                title: [{ required: true, message: "请输入", trigger: "blur" }],
                content: [{ required: true, message: "请输入", trigger: "blur" }],
                pubDate: [{ required: true, message: "请输入", trigger: "blur" }],
            };
        },
    },
    created() {
        this.dataForm.cunNameList = this.cunNameList
        // this.getPersonList()
    },
    methods: {
        init() {
            this.visible = true;
            this.getPersonList()
            // this.$nextTick(() => {
            //     this.$refs['dataForm'].resetFields()
            //     if (this.dataForm.id) {
            //         this.getInfo()
            //     }
            // })
        },
        echoFun() {
            if (this.echoList) {
                let list = []
                this.echoList.forEach(item => {
                    list = [...list, ...item.cjIds]
                })
                // console.log(list, '回显村民数据');
                list.forEach(key => {
                    this.dataList.forEach(row => {
                        if (row.id == key) {
                            this.$nextTick(() => {
                                this.$refs.multipleTable.toggleRowSelection(row, true);
                            })

                        }
                    })
                })
            }
        },
        getPersonList() {
            this.dataListLoading = true
            axios.post(this.$baseURL+'/api/cx/cxUserList', this.dataForm)
                .then(({ data: res }) => {
                    this.dataListLoading = false
                    if (res.code !== 0) {
                        return this.$message.error(res.msg);
                    }
                    this.dataList = res.list;
                    this.echoFun()
                })
                .catch(() => {
                    this.dataListLoading = false
                });
        },
        // 多选
        dataListSelectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 排序
        dataListSortChangeHandle(data) {
            if (!data.order || !data.prop) {
                this.order = ''
                this.orderField = ''
                return false
            }
            this.order = data.order.replace(/ending$/, '')
            this.orderField = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
            this.query()
        },
        dataFormSubmitHandle() {
            //选中人员之后确认
            let relateList = []
            let cunIDs = {}
            this.dataListSelections.forEach(item => {
                this.$set(cunIDs, item.cunId, item.cunId)
            });
            for (let i in cunIDs) {
                relateList.push({ cunId: i, cjIds: [] })
                this.dataListSelections.forEach(item => {
                    relateList.forEach(item1 => {
                        if (item.cunId == item1.cunId) {
                            item1.cjIds.push(item.id)
                        }
                    })
                });
            }
            // console.log(relateList, '选中的村民');
            this.innerVisible = false
            this.$emit('close', relateList)
        },
    },
};
</script>
